import { useEffect, useState } from "react";
import http from "@/lib/api";
import { Panel, Empty, fmt } from "./AdminKit";

function ContactCard({ r, onChange }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async (fn) => {
    setBusy(true);
    try { await fn(); onChange(); } catch { /* reload shows state */ } finally { setBusy(false); }
  };
  const addNote = () => note.trim() && run(async () => { await http.post(`/v1/admin/contacts/${r.id}/note`, { text: note }); setNote(""); });
  const setStatus = (s) => run(() => http.post(`/v1/admin/contacts/${r.id}/status?status=${s}`));
  const done = r.contact_status === "done";
  const byPhone = r.contact_method !== "email";
  return (
    <div className={`rounded-lg border p-3 space-y-2 text-sm ${done ? "border-slate-700 opacity-70" : "border-amber-700/60 bg-amber-950/20"}`} data-testid={`contact-${r.id}`}>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
        <span className="text-white font-medium" data-testid={`contact-name-${r.id}`}>{r.customer_name || "—"}</span>
        <span className="text-xs px-2 py-0.5 rounded bg-slate-700 text-slate-200" data-testid={`contact-method-${r.id}`}>{byPhone ? "Позвонить" : "Написать email"}</span>
        {byPhone
          ? <a href={`tel:${r.phone}`} className="text-emerald-400 font-mono" data-testid={`contact-phone-${r.id}`}>{r.phone || "—"}</a>
          : <a href={`mailto:${r.email}`} className="text-emerald-400" data-testid={`contact-email-${r.id}`}>{r.email || "—"}</a>}
        <span className="text-slate-400">{String(r.language || "").toUpperCase()}</span>
        {r.priority && r.priority !== "normal" && <span className="text-red-400 uppercase text-xs">{r.priority}</span>}
        <span className="text-slate-500 text-xs">{fmt(r.created_at)} · {r.source === "vadim_voice" ? "голос" : "чат"}</span>
      </div>
      <div className="text-slate-200" data-testid={`contact-topic-${r.id}`}>{r.contact_topic}</div>
      {(r.contact_notes || []).map((n, i) => (
        <div key={i} className="text-xs text-slate-400 border-l-2 border-slate-600 pl-2">{fmt(n.at)}: {n.text}</div>
      ))}
      <div className="flex flex-wrap gap-2">
        <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Заметка (напр. не ответил)" className="flex-1 min-w-[180px] rounded bg-slate-900 border border-slate-600 text-slate-200 p-2 text-xs" data-testid={`contact-note-input-${r.id}`} />
        <button disabled={busy} onClick={addNote} className="px-3 py-1.5 rounded bg-slate-700 hover:bg-slate-600 text-white text-xs disabled:opacity-40" data-testid={`contact-note-btn-${r.id}`}>Добавить заметку</button>
        {done
          ? <button disabled={busy} onClick={() => setStatus("open")} className="px-3 py-1.5 rounded bg-slate-700 text-white text-xs" data-testid={`contact-reopen-btn-${r.id}`}>Вернуть в открытые</button>
          : <button disabled={busy} onClick={() => setStatus("done")} className="px-3 py-1.5 rounded bg-emerald-700 hover:bg-emerald-600 text-white text-xs" data-testid={`contact-done-btn-${r.id}`}>Связался ✓</button>}
      </div>
    </div>
  );
}

export default function AdminContactRequests() {
  const [status, setStatus] = useState("open");
  const [rows, setRows] = useState([]);
  const load = () => http.get(`/v1/admin/contacts?status=${status}`).then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, [status]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="space-y-6" data-testid="admin-contact-requests">
      <h1 className="text-2xl font-bold text-white">Связаться с клиентом</h1>
      <div className="flex gap-2">
        {[["open", "Открытые"], ["done", "Выполненные"], ["all", "Все"]].map(([k, l]) => (
          <button key={k} onClick={() => setStatus(k)} className={`px-3 py-1.5 rounded text-xs ${status === k ? "bg-blue-600 text-white" : "bg-slate-800 text-slate-300"}`} data-testid={`contacts-filter-${k}`}>{l}</button>
        ))}
      </div>
      <Panel title={`Запросы на связь: ${rows.length}`}>
        {rows.length === 0 ? <Empty /> : <div className="space-y-3">{rows.map((r) => <ContactCard key={r.id} r={r} onChange={load} />)}</div>}
      </Panel>
    </div>
  );
}
